import LoginForm from "../components/LoginForm";

function Login() {
  document.title = "TicketBlaster | Log In";

  return <LoginForm />;
}

export default Login;
